import {styled, TableRow} from "@mui/material";
import theme2 from "../lib/theme";

const TableHeaderRow = styled(TableRow)(({ theme }) => ({
    'th': {
        backgroundColor: "#eeeeee",
        fontWeight: 'bold',
        userSelect: 'text',
        WebkitUserSelect: 'text',
    },
    // MUI defaults TableSortLabel to user-select:none, which blocks copying headers with data.
    '& .MuiTableSortLabel-root': {
        userSelect: 'text',
        WebkitUserSelect: 'text',
    },
}));

export default TableHeaderRow;
